import * as React from "react";
import {observer} from "mobx-react-lite";
import {
    CCard,
    CCardContent,
    CGrid,
} from "../../components";

export const Settings = observer(
    function Settings() {

        return (
            <>
                <CGrid container spacing={2}>
                    <CGrid item xs={12}>
                        <CCard sx={{height: 128}}>
                            <CCardContent>

                            </CCardContent>
                        </CCard>
                    </CGrid>
                    <CGrid item xs={8}>
                        <CCard sx={{height: 300}}>
                            <CCardContent>

                            </CCardContent>
                        </CCard>
                    </CGrid>
                    <CGrid item xs={4}>
                        <CCard sx={{height: 300}}>
                            <CCardContent>

                            </CCardContent>
                        </CCard>
                    </CGrid>
                    <CGrid item xs={4}>
                        <CCard sx={{height: 300}}>
                            <CCardContent>

                            </CCardContent>
                        </CCard>
                    </CGrid>
                    <CGrid item xs={8}>
                        <CCard sx={{height: 300}}>
                            <CCardContent>

                            </CCardContent>
                        </CCard>
                    </CGrid>
                    <CGrid item xs={8}>
                        <CCard sx={{height: 300}}>
                            <CCardContent>

                            </CCardContent>
                        </CCard>
                    </CGrid>
                    <CGrid item xs={4}>
                        <CCard sx={{height: 300}}>
                            <CCardContent>

                            </CCardContent>
                        </CCard>
                    </CGrid>
                    <CGrid item xs={4}>
                        <CCard sx={{height: 300}}>
                            <CCardContent>

                            </CCardContent>
                        </CCard>
                    </CGrid>
                    <CGrid item xs={8}>
                        <CCard sx={{height: 300}}>
                            <CCardContent>

                            </CCardContent>
                        </CCard>
                    </CGrid>
                    <CGrid item xs={8}>
                        <CCard sx={{height: 300}}>
                            <CCardContent>

                            </CCardContent>
                        </CCard>
                    </CGrid>
                    <CGrid item xs={4}>
                        <CCard sx={{height: 300}}>
                            <CCardContent>

                            </CCardContent>
                        </CCard>
                    </CGrid>
                    <CGrid item xs={4}>
                        <CCard sx={{height: 300}}>
                            <CCardContent>

                            </CCardContent>
                        </CCard>
                    </CGrid>
                    <CGrid item xs={8}>
                        <CCard sx={{height: 300}}>
                            <CCardContent>

                            </CCardContent>
                        </CCard>
                    </CGrid>
                </CGrid>
            </>
        );
    }
)
